<template>
  <!-- 大会员打卡0元购 -->
  <div class="sign" v-pageBuried data-page-buried="BG_VIP_HD_0YDK_DK_2">
    <div class="container" v-if="loaded">
      <!-- <div class="activity-time">
                <img class="time-image"
                    src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/607357a8fc46c7d6453b6d71beb54022.png" alt="">
                <div class="time-duration">03.26-03.31</div>
            </div> -->
      <div class="back-container">
        <AppNavBar
          :placeholder="true"
          :options="options"
          :back="false"
          :showTabBar="false"
        ></AppNavBar>
        <div class="back-wrapper">
          <div class="back" @click="bindBack"
            ><span class="iconfont icon-fanhui"></span
          ></div>
          <div class="btn-list">
            <div class="btn-item" @click="bindShowRule"><span>规则</span></div>
          </div>
        </div>
      </div>
      <div class="wrapper">
        <div class="top">
          <div v-if="signInfo">
            <SignContent
              v-if="signInfo"
              ref="sign"
              @sign="bindSign"
              @success="bindSuccess"
              @error="bindError"
              :data="signInfo"
            />
            <!--  <TipComponent /> -->
            <TaskContent
              v-if="taskData"
              :data="taskData"
              :status="signInfo && signInfo.user_plan_state"
              @task="bindClickItem"
            />
          </div>
          <PrizeComponent />
          <RuleComponent />
        </div>
        <img
          class="logo"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
          alt=""
        />
      </div>
    </div>
    <!-- 弹框 -->
    <van-overlay :show="showToast" @click="showToast = false" z-index="2000">
      <div class="toast-wrapper animate__animated animate__bounceIn">
        <NotQualificationToast @confirm="bindConfirm" />
      </div>
    </van-overlay>
    <!-- 首次提醒弹框 -->
    <van-overlay
      :show="showFirstToast"
      @click="showFirstToast = false"
      z-index="2000"
    >
      <div class="toast-wrapper animate__animated animate__bounceIn">
        <FirstTipsToast @confirm="bindConfirmFirst" @cancel="bindCancelFirst" />
      </div>
    </van-overlay>
    <!--  -->
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindShareCancel"
      @select="bindShareSelect"
    />
  </div>
</template>
<script>
import { eventObj } from '@/components/app/share/share-method.js'
import AppNavBar from '@/components/app/nav-bar/index.vue'
import SignContent from './components/activity2/sign.vue'
import TaskContent from './components/activity2/task.vue'
import NotQualificationToast from './components/activity2/not-qualification-toast.vue'
import FirstTipsToast from './components/activity2/first-tips-toast.vue'
import ShareComponent from '@/components/app/share/share.vue'
import NoticeComponent from './components/activity2/notice-component.vue'
import PrizeComponent from './components/activity2/prize.vue'
import RuleComponent from './components/activity2/rule.vue'
import TipComponent from './components/activity2/tip.vue'
export default {
  name: 'user-sign-index',
  components: {
    SignContent,
    TaskContent,
    NotQualificationToast,
    ShareComponent,
    NoticeComponent,
    PrizeComponent,
    RuleComponent,
    AppNavBar,
    FirstTipsToast,
    TipComponent
  },
  props: {
    activityId: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      options: { barBackgroundColor: 'rgba(0,0,0,0)' },
      toastType: 1,
      activity_id: 2,
      loaded: true,
      showToast: false,
      signInfo: {
        user_plan_state: 0,
        is_sign: 0,
        day_num: 0
      },
      showFirstToast: false,
      taskData: null,
      showShare: false,
      qrcodeUrl: 'https://btvue.gymcity.com.cn/app-download',
      shareOptions: {
        title: '0元得WE+会员年卡',
        desc: '挑战两个月瘦15斤',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-share-image'
      },
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        }
      ]
    }
  },
  created() {
    this.getParams()
    this.addEventPage()
    this.getSignInfo()
    this.getTaskInfo()
  },
  methods: {
    getParams() {
      this.activity_id = this.activityId
    },
    addEventPage() {
      window.onPageResumed = () => {
        this.getSignInfo()
        this.getTaskInfo()
      }
    },
    bindShare() {
      if (!this.signInfo) {
        return
      }
      this.showShare = true
    },
    bindShareCancel() {
      this.showShare = false
    },
    bindSuccess() {
      this.$betterwe.jumpRoute(
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fc6c39d03fae63c8570fc273aa46f499e.png'
      )
    },
    bindError() {
      this.$betterwe.jumpRoute(
        '/miniProgram?userName=gh_0d804ee2c21b&path=pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2F4f63ae39b2f5b1e2b49eb934260ec3ec.png'
      )
    },
    bindShareSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
      }
    },
    bindShowRule() {
      let el = document.getElementById('activity-rule')
      el?.scrollIntoView()
    },
    bindBack() {
      this.$http.appBack()
    },
    bindConfirm() {
      this.showToast = false
      this.$betterwe.vipHomePage()
    },
    bindSign() {
      this.activityQualification(this.bindClickClock)
    },
    bindCancelFirst() {
      this.showFirstToast = false
    },
    /* 判断资格，如果有资格则执行回调函数 */
    async activityQualification(calback, ...params) {
      if (this.signInfo.user_plan_state == 0) {
        let isQualification = await this.getHasQualification()
        if (!isQualification) {
          this.showToast = true
        } else {
          this.toastConfirmCallBack = calback
          this.toastConfirmParams = params
          this.showFirstToast = true
        }
      } else if (this.signInfo.user_plan_state == 3) {
        calback(...params)
      }
    },
    async bindConfirmFirst() {
      this.showFirstToast = false
      let res = await this.initQualification()
      if (res) {
        this.toastConfirmCallBack(...this.toastConfirmParams)
      }
    },
    /* 去打卡 */
    async bindClickClock() {
      let res = await this.$http
        .getBaseApp('api/v1/UserCenter/getUserProfile', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (!res.data.is_app_weight_goal) {
            this.$betterwe.jumpRoute('/userProfileInputSex?pageType=1')
          } else {
            this.jumpClock()
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    jumpClock() {
      for (let item of this.taskData) {
        if (item.plan_id == 5) {
          this.$betterwe.jumpRoute(item.jump_url)
          return
        }
      }
      this.$toast('未找到任务')
    },
    bindToPrizePage() {
      this.$router.push('/user-sign/prize-list')
    },
    signApi() {
      this.$http
        .postAppWithAppInfo('api/v1/SignActivity/signIn', {
          activity_id: this.activity_id
        })
        .then((res) => {
          res = res.data
        })
        .catch(() => {})
    },
    /* 获取是否有资格 */
    async getHasQualification() {
      let res = await this.$http.getAppWithAppInfo(
        'api/v1/SignActivity/checkPrivilege',
        { activity_id: this.activity_id }
      )
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data) {
            return !!res.data.can_participate
          }
        }
      }
    },
    /* 初始化开始挑战 */
    async initQualification() {
      return new Promise(async (resolve, reject) => {
        let res = await this.$http
          .getAppWithAppInfo('api/v1/SignActivity/zeroBuyStart', {
            activity_id: this.activity_id
          })
          .catch(() => {
            reject(false)
          })
        if (res) {
          res = res.data
          if (res.code == 200) {
            resolve(true)
          } else {
            this.$toast(res.msg)
            reject(false)
          }
        }
      })
    },
    /* 获取签到信息 */
    getSignInfo() {
      this.$http
        .getAppWithAppInfo('api/v1/SignActivity/zeroBuyActivityInfo', {
          activity_id: this.activity_id
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data) {
              this.signInfo = res.data
            }
          } else if (res.code == 10001) {
            this.$toast('抱歉,您暂未获取活动资格')
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    getTaskInfo() {
      this.$http
        .getAppWithAppInfo('api/v1/Vote/getVotePlanList', {
          activity_id: this.activity_id,
          activity_source: 1
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.taskData = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    async completeTask(id) {
      let res = await this.$http
        .postApp('api/v1/Vote/completePlan', {
          plan_id: id,
          activity_id: this.activityId
        })
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.getTaskInfo()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async bindClickItem(item) {
      this.activityQualification(this.bindToCompleteTask, item)
    },
    bindToCompleteTask(item) {
      /* 如果任务锁定了 */
      if (item.is_lock) {
        let relateTask = this.taskData.find((item1) => {
          return item1.id == item.relate_plan_id
        })
        if (relateTask) {
          this.$toast('请先完成第一个任务“' + relateTask.name + '”')
        } else {
          this.$toast('前置解锁任务不存在')
        }
        return
      }
      if (!item.plan_state) {
        //未完成
        switch (item.complete_type) {
          case 1:
            /* 点击即可完成 */
            this.completeTask(item.plan_id)
            this.$betterwe.jumpRoute(item.jump_url)
            break
          case 2:
            this.$betterwe.jumpRoute(item.jump_url)
            break
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.sign {
  .back-container {
    position: fixed;
    z-index: 2;
    width: 100%;
    top: 0;
    left: 0;
  }

  .container {
    overflow: hidden;
    min-height: 100vh;
    background-color: rgba(97, 221, 231, 1);
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e9f8ca8c6a6cbd5e7d6e2c9fbc0db134.png');
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center top;

    .back {
      z-index: 999;
      position: absolute;
      left: 14px;
      top: 20px;
      width: 30px;
      height: 30px;
      background: rgba(0, 0, 0, 0.16);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .iconfont {
        color: #fff;
        font-size: 18px;
      }
    }

    .back-wrapper {
      position: relative;
    }

    .btn-list {
      z-index: 999;
      position: absolute;
      right: 14px;
      top: 20px;
      display: flex;
      flex-direction: column;

      .btn-item {
        margin-bottom: 12px;
        width: 30px;
        height: 30px;
        background: rgba(0, 0, 0, 0.16);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 20px;

        .iconfont {
          font-size: 14px;
          font-weight: 700;
        }
      }
    }

    .activity-time {
      position: absolute;
      left: 0;
      top: 86px;

      .time-image {
        width: 134px;
        height: 61px;
      }

      .time-duration {
        font-family: PingFangSC, PingFang SC;
        padding: 0px 6px;
        font-weight: bold;
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        position: absolute;
        transform: rotate(-5deg);
        top: 33px;
        left: 0;
      }
    }

    .wrapper {
      margin-top: 511px;

      .top {
        position: relative;
        padding: 0px 14px;
        margin-bottom: 27px;

        .notice-component {
          position: absolute;
          position: absolute;
          left: 0px;
          top: -46px;
          width: 100%;
          padding: 0px 14px;
          box-sizing: border-box;
          height: 40px;
          z-index: 999;
          overflow: hidden;
        }

        .prize-user-container {
          width: 100%;
          height: 40px;
          position: absolute;
          left: 0px;
          top: -46px;

          .prize-user-overflow {
            height: 100%;
            overflow: hidden;
          }

          .prize-user-content {
            height: 26px;

            ::v-deep .van-notice-bar {
              height: 100%;
            }

            ::v-deep .van-notice-bar__wrap {
              overflow: visible;
            }

            ::v-deep .van-ellipsis {
              overflow: visible;
            }

            ::v-deep .van-swipe {
              overflow: visible;
            }
          }
        }

        .prize-user-swipe {
          height: 26px;

          .prize-user-item {
            display: inline-block;
            padding: 0px 7px;
            white-space: nowrap;
            height: 20px;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 10px;
            backdrop-filter: blur(6px);
            font-size: 10px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            color: #ffffff;
            line-height: 20px;
          }
        }

        .integral-content {
          height: 50px;
          display: flex;
          align-items: center;
          background: rgba(255, 255, 255, 0.93);
          box-shadow: 0px 5px 9px 0px rgba(75, 195, 156, 0.47);
          border-radius: 26px;
          border: 2px solid #ffffff;
          backdrop-filter: blur(9px);
          margin-bottom: 17px;
          position: relative;

          .mask {
            border-radius: 25px;
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            overflow: hidden;
          }

          .integral-dot-filter {
            position: absolute;
            width: 125px;
            height: 125px;
            background-color: #fff9cd;
            border-radius: 50%;
            filter: blur(36px);
            left: -46px;
            top: -90px;
          }

          .integral-item {
            position: relative;
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .integral-flag {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%, -90%);
              width: 104px;
              height: 22px;
              object-fit: contain;
            }

            .integral-icon {
              width: 20px;
              height: 20px;
              margin-right: 6px;
            }

            .integral-text {
              font-size: 18px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.8);
              line-height: 25px;
            }

            .integral-num {
              position: relative;
              font-size: 26px;
              font-family: DIN, DIN;
              font-weight: bold;
              color: #ff6464;
              line-height: 31px;
              margin-right: 4px;
            }

            .iconfont {
              font-size: 18px;
              font-weight: 600;
              color: rgba(0, 0, 0, 0.3);
            }
          }

          .integral-item-first::after {
            content: '';
            position: absolute;
            top: 50%;
            right: 0%;
            transform: translate(-50%, -50%);
            width: 1px;
            height: 16px;
            background-color: rgba(0, 0, 0, 0.12);
          }
        }
      }

      .logo {
        margin: 0 auto 28px;
        height: 16px;
      }
    }
  }
}

.toast-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
